import { useTranslation } from 'react-i18next'
interface CardRefreshButtonProps {
  onRefresh: () => Promise<void> | void
  loading?: boolean
  disabled?: boolean
  className?: string
}

export default function CardRefreshButton({
  onRefresh,
  loading = false,
  disabled = false,
  className = ''
}: CardRefreshButtonProps) {
  const { t } = useTranslation('common')

  const handleRefresh = async () => {
    if (loading || disabled) return

    try {
      await onRefresh()
    } catch (error) {
      console.error('Card refresh failed:', error)
    }
  }

  return (
    <button
      onClick={handleRefresh}
      disabled={disabled || loading}
      className={`
        inline-flex items-center justify-center
        w-8 h-8 rounded-full
        text-gray-400 hover:text-gray-600 hover:bg-gray-100
        focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-1
        disabled:opacity-50 disabled:cursor-not-allowed
        transition-all duration-200 ease-in-out
        ${className}
      `}
      title={t('refresh')}
    >
      <svg
        className={`w-4 h-4 ${loading ? 'animate-spin' : ''}`}
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
        />
      </svg>
    </button>
  )
}